export default __webpack_public_path__ + "static/media/sendIcon.5a1bfadf.PNG";